import { CommApiInstance } from "Utils/CommApiInstance";

const ItemOdrPchsApi = async (
    gameSvcCd:string,
    prdtKindCd:string,
    prdtCd:string,
    prdtCnt:number,
    prdtPrc:string,
    odrAmt:string,
) => {
    
    return await CommApiInstance.post(`/pymt/${gameSvcCd}/item_odr/pchs`,{
        apiBody:{
            prdtKindCd,
            prdtCd,
            prdtCnt,
            prdtPrc,
            odrAmt,
        },
    })
    .then((Resp) => Resp.data);
    
}
export default ItemOdrPchsApi;